var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWlMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#6941C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1331 14.88L20.8371 26H18.7731L16.4371 17.584L13.9571 26L11.9091 26.016L8.75713 14.88H10.6931L12.9971 23.936L15.4931 14.88H17.5411L19.8611 23.888L22.1811 14.88H24.1331ZM27.4615 24.528H31.2215V26H25.6375V14.88H27.4615V24.528Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWlMark);
export default __webpack_public_path__ + "static/media/WL-mark.93361611c21d14a6ae738cbcf000b5ad.svg";
export { ForwardRef as ReactComponent };